import type { TimestampInMillis } from './dates';
import type { Vehicle } from './vehicle';

export interface FuelCostByDay {
  dateInMillis: TimestampInMillis;
  cost: number;
  driversId: string[];
  distanceDrivenInMeters: number;
}

export interface FuelCosts {
  [vehicleId: string]: FuelCostByDay[];
}

export interface MaintenanceCostsByDay {
  dateInMillis: TimestampInMillis;
  corrective: number;
  preventive: number;
}

export interface MaintenanceCosts {
  [vehicleId: string]: MaintenanceCostsByDay[];
}

export interface DriverNames {
  [driverId: string]: string;
}

export interface DailyCost {
  date: TimestampInMillis;
  distanceDrivenInMeters: number;
  fuelCost: number;
  preventiveMaintenanceCost: number;
  correctiveMaintenanceCost: number;
  drivers: string[];
}

export interface Costs {
  vehicleId: string;
  costInfo: DailyCost[];
  fuelCost: number;
  maintenanceCost: number;
  drivenDistanceInMeters: number;
}

export const toFormattedStringMoney = (value: number): string =>
  Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);

export interface CostsWithVehicle extends Costs {
  vehicle: Vehicle;
  withDashCam: boolean;
}
